import type { AnyPopup, IAlertPopup, IDialogPopup, IFloatingPopup, IMenuPopup, PopupType } from '@pressreader/popups-types';

function isDialogPopup(popup: AnyPopup): popup is IDialogPopup {
    return popup?.type === 'dialog';
}

function isMenuPopup(popup: AnyPopup): popup is IMenuPopup {
    return popup?.type === 'menu';
}

function isAlertPopup(popup: AnyPopup): popup is IAlertPopup {
    return popup?.type === 'alert';
}

function isFloatingPopup(popup: AnyPopup): popup is IFloatingPopup {
    return popup?.type === 'floating';
}

/**
 * Whether the popup blocks the page under it. Every kind but the floating one is modal; the floating popup is
 * non-modal, so everything keyed on "a popup is open" ignores it. Takes anything carrying the popup type, so a
 * `popupClosed` payload qualifies as well as a store entry.
 */
function isBlockingPopup(popup: { type: PopupType }): boolean {
    return popup.type !== 'floating';
}

export { isAlertPopup, isBlockingPopup, isDialogPopup, isFloatingPopup, isMenuPopup };
